<template>
  <WsMain>
    <WsCRUD
      orderWay="asc"
      orderBy="sequence"
      :label="label"
      :fields="fields"
      :modelName="modelName"
      :showFields="showFields"
      :inRowBtnRead="false"
    />
  </WsMain>
</template>

<script>
import model from '@/models/topic';

export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      showFields: [
        'sequence',
        'name',
        'value',
        'updated_at',
        'updated_admin',
      ],
    };
  },
};
</script>